import { createAsyncThunk } from "@reduxjs/toolkit";
import reservationApi from "../../api/reservationApi";
import normalizeAxiosError from "../../utils/normalizeAxiosError";

// -------------------------- Section ATELIERS -------------------------
export const fetchAteliers = createAsyncThunk(
  "reservation/fetchAteliers",
  async (_, { rejectWithValue }) => {
    try {
      return await reservationApi.getAteliers();
    } catch (err) {
      return rejectWithValue(normalizeAxiosError(err));
    }
  }
);

export const createAtelier = createAsyncThunk(
  "reservation/createAtelier",
  async (atelierData, { rejectWithValue }) => {
    try {
      return await reservationApi.createAtelier(atelierData);
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la création de l’atelier")
      );
    }
  }
);

export const updateAtelier = createAsyncThunk(
  "reservation/updateAtelier",
  async (data, { rejectWithValue }) => {
    try {
      return await reservationApi.updateAtelier(data.atelier_id, data);
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la mise à jour de l’atelier")
      );
    }
  }
);

export const deleteAtelier = createAsyncThunk(
  "reservation/deleteAtelier",
  async (data, { rejectWithValue }) => {
    try {
      await reservationApi.deleteAtelier(data.atelier_id);
      return data.atelier_id;
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la suppression de l’atelier")
      );
    }
  }
);

// -------------------------- Section ZONES -------------------------
export const fetchZones = createAsyncThunk(
  "reservation/fetchZones",
  async (_, { rejectWithValue }) => {
    try {
      return await reservationApi.getZones();
    } catch (err) {
      return rejectWithValue(normalizeAxiosError(err));
    }
  }
);

export const createZone = createAsyncThunk(
  "reservation/createZone",
  async (atelierData, { rejectWithValue }) => {
    try {
      return await reservationApi.createZone(atelierData);
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la création d'une nouvelle zone")
      );
    }
  }
);

export const updateZone = createAsyncThunk(
  "reservation/updateZone",
  async (data, { rejectWithValue }) => {
    try {
      return await reservationApi.updateZone(data.zone_id, data);
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la mise à jour d'une zone")
      );
    }
  }
);

export const deleteZone = createAsyncThunk(
  "reservation/deleteZone",
  async (data, { rejectWithValue }) => {
    try {
      await reservationApi.deleteZone(data.zone_id);
      return data.zone_id;
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Erreur lors de la suppression de la zones")
      );
    }
  }
);

// -------------------------- Section DISPONIBILITE -------------------------
export const fetchDisponibiliteMois = createAsyncThunk(
  "reservation/fetchDisponibiliteMois",
  async ({ annee, mois, atelier }, { rejectWithValue }) => {
    try {
      return await reservationApi.getDisponibiliteMois({ annee, mois, atelier });
    } catch (err) {
      return rejectWithValue(normalizeAxiosError(err));
    }
  }
);

export const fetchDisponibiliteJour = createAsyncThunk(
  "reservation/fetchDisponibiliteJour",
  async ({ date, atelier }, { rejectWithValue }) => {
    try {
      return await reservationApi.getDisponibiliteJour({ date, atelier });
    } catch (err) {
      return rejectWithValue(normalizeAxiosError(err));
    }
  }
);

export const fetchMonthReservations = createAsyncThunk(
  "reservation/fetchMonthReservations",
  async ({ annee, mois }, { rejectWithValue }) => {
    try {
      return await reservationApi.getMonthReservations({ annee, mois });
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Impossible de récupérer les réservations du mois")
      );
    }
  }
);

export const sendReservation = createAsyncThunk(
  "reservation/sendReservation",
  async (payload, { rejectWithValue }) => {
    try {
      return await reservationApi.createReservation(payload);
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Impossible de contacter le serveur")
      );
    }
  }
);

export const fetchReservationsBySlot = createAsyncThunk(
  "reservation/fetchReservationsBySlot",
  async ({ date, heure, zone, filtreAnnule }, { rejectWithValue }) => {
    try {
      if (!date) throw new Error("La date est obligatoire");
      return await reservationApi.getReservationsBySlot({
        date,
        heure,
        zone,
        filtreAnnule,
      });
    } catch (err) {
      return rejectWithValue(
        normalizeAxiosError(err, "Impossible de récupérer les réservations")
      );
    }
  }
);

export const reservationThunks = [
  fetchAteliers,
  createAtelier,
  updateAtelier,
  deleteAtelier,
  fetchZones,
  createZone,
  updateZone,
  deleteZone,
  fetchDisponibiliteMois,
  fetchDisponibiliteJour,
  fetchMonthReservations,
  sendReservation,
  fetchReservationsBySlot,
];

export const reservationLoadingGroups = {
  ateliers: fetchAteliers,
  zones: fetchZones,
  disponibiliteMois: fetchDisponibiliteMois,
  disponibiliteJour: fetchDisponibiliteJour,
  monthReservations: fetchMonthReservations,
  reservationDetails: fetchReservationsBySlot,
};
